export default __webpack_public_path__ + "static/media/singlebed2.e4317b9a.jpg";